import { HomePage } from "./home/HomePage";

function App() {
  return <HomePage />;
}

export default App;
